import { ILED } from '../IComponents.js';

/**
 * BasicLED - Simple CSS-based LED indicator
 */
export class BasicLED extends ILED {
    constructor(container, options) {
        super(container, options);
        this.isOn = options.on ?? false;
        this._create();
    }

    _create() {
        const { color = 'red', size = 'small' } = this.options;

        this.element = document.createElement('div');
        this.element.className = `led led-${size}`;
        this.element.style.setProperty('--led-color', this._getColorValue(color));

        if (this.isOn) {
            this.element.classList.add('on');
        }

        this.container.appendChild(this.element);
    }

    _getColorValue(color) {
        const colors = {
            red: '#ff3333',
            green: '#33ff33',
            yellow: '#ffff33',
            orange: '#ff9933',
            blue: '#3399ff'
        };
        return colors[color] || color;
    }

    getValue() {
        return this.isOn;
    }

    setValue(value) {
        this.isOn = value;
        this.element.classList.toggle('on', this.isOn);
    }

    on() {
        this.setValue(true);
    }

    off() {
        this.setValue(false);
    }

    toggle() {
        this.setValue(!this.isOn);
    }
}
